module Meevo.Plugins.SaleProgram {
    class ServicesFilterController {
        static $inject = [
            "meevo.components.modal.ModalService", "$mdDialog", "context"
        ];

        private subCategoryId: string;
        private displayName: string;

        constructor(private modalService: Meevo.Components.Modal.IModalService, private $mdDialog, private context) {
            this.subCategoryId = context.subCategoryId;
            this.displayName = context.displayName;
        }

        clearFilter = (): void => {
            this.context.subCategoryId = null;
            this.context.displayName = null;
            this.closeModal();
        }

        applyFilter = (): void => {
            this.context.subCategoryId = this.subCategoryId;
            this.context.displayName = this.displayName;
            this.closeModal();
        }

        closeModal = (): void => {
            this.$mdDialog.cancel();
        }
    }

    angular.module("meevo.plugins.saleProgram")
        .controller("meevo.plugins.saleProgram.ServicesFilterController", ServicesFilterController);
}
